import {inject, Injectable, signal} from '@angular/core';
import {ChatTelegram} from "../types/chat-telegram.types";
import {TelegramPageService} from "./telegram-page.service";
import {TelegramService} from "./telegram.service";

@Injectable({
  providedIn: 'root'
})
export class TelegramChatsService {
  private telegramService: TelegramService = inject(TelegramService);
  private telegramPageService: TelegramPageService = inject(TelegramPageService);
  private _chatId = signal<number>(0);
  private _chat = signal<ChatTelegram | null>(null);
  private _chats = signal<Array<ChatTelegram>>([]);
  public chatId = this._chatId.asReadonly();
  public chat = this._chat.asReadonly();
  public chats = this._chats.asReadonly();

  public setChat(chatId: number): void {
    const chat = this.chats().find(i => i.id === chatId) || null;

    this._chat.set(chat);
  }

  public async setChats(): Promise<void> {
    const chatsQueryParams = this.telegramPageService.setChatsQueryParams();
    const chats = await this.telegramService.getMainChats(chatsQueryParams).catch(() => []);
    this._chats.set(chats);
  }
}
